import { useContext } from 'react';
import { FilterBlockContext } from '../../block/FilterBlock/FilterBlock.context';
import { FilterBlockItemBase } from '../FilterBlockItemBase/FilterBlockItemBase';

export const useFilterBlockItemComponent = () => {
  const { FilterBlockItemComponent } = useContext(FilterBlockContext) ?? {};

  return FilterBlockItemComponent ?? FilterBlockItemBase;
};
